import {
  useVideoCameraExplicitLockMutation,
  useUnlockPtzVideoCameraMutation,
} from '@kinetic-ui/data-layer';
import { VideoPlayerCamera } from 'types/videoPlayerTypes';

export const useTogglePTZLock = (camera?: VideoPlayerCamera, refetchData?: () => void) => {
  const ptzLock = camera?.ptzLock;

  const [unlockPtzCameraMutation] = useUnlockPtzVideoCameraMutation();
  const [cameraExplicitLockMutation] = useVideoCameraExplicitLockMutation();

  const togglePTZLock = (isOverride?: boolean) => {
    if (isOverride) {
      camera?.id &&
        unlockPtzCameraMutation({
          variables: {
            cameraId: camera.id,
          },
        }).then(() =>
          cameraExplicitLockMutation({
            variables: {
              cameraId: camera.id,
            },
          }).then(() => refetchData?.())
        );
      return;
    }
    if (ptzLock?.isLocked) {
      camera?.id &&
        unlockPtzCameraMutation({
          variables: {
            cameraId: camera.id,
          },
        }).then(() => refetchData?.());
      return;
    }
    if (!ptzLock?.isLocked) {
      camera?.id &&
        cameraExplicitLockMutation({
          variables: {
            cameraId: camera.id,
          },
        }).then(() => refetchData?.());
    }
  };

  return {
    togglePTZLock,
  };
};
